<button
  type="button"
  class="selectable-tile h-full w-full flex flex-col gap-2 border rounded-lg p-4 text-left text-cp-primary-100 cursor-pointer transition-colors hover:border-cp-primary-100"
  [class.border-cp-secondary-100]="selected()"
  [class.border-cp-primary-20]="!selected()"
  [attr.aria-pressed]="selected()"
  [matTooltip]="tooltip() ?? ''"
  (click)="toggled.emit()"
>
  <div class="flex justify-between items-start gap-2">
    <span class="font-medium">{{ title() }}</span>
    @if (selected()) {
      <mat-icon svgIcon="cp-check" class="shrink-0" />
    }
  </div>

  @if (description(); as text) {
    <p class="text-sm">{{ text }}</p>
  }

  @if (logoUrl(); as logo) {
    <img [src]="logo" alt="" class="h-8 w-8 object-contain self-end mt-auto" />
  }
</button>
